import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../commonDesign/SydModal'
import SydButton from '../../../../commonDesign/Button'
import SydModalActions from '../../../../commonDesign/SydModal/SydModalActions'
import { actionTemplates } from '../../../../../api/coreData'

const SetActiveVersionDialog = React.forwardRef(function SetActiveVersionDialog ({ template, onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, version: null })
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(null)
  const { mutateAsync: setActiveVersion } = actionTemplates.useSetActiveActionTemplateVersion()

  const close = useCallback(() => {
    setDialogState({ open: false, version: null })
    setError(null)
  }, [])

  useImperativeHandle(ref, () => ({
    open: (version) => setDialogState({ open: true, version })
  }), [])

  const handleSetActive = useCallback(async () => {
    try {
      setProcessing(true)
      setError(null)
      await setActiveVersion({
        actionTemplateId: template.actionTemplateId,
        definitionVersionId: dialogState.version.definitionVersionId
      })
      close()
      onComplete()
    } catch (err) {
      setError(err.message || 'Failed to set active version')
    } finally {
      setProcessing(false)
    }
  }, [setActiveVersion, template, dialogState, close, onComplete])

  return (
    <SydModal
      title='Set Active Version'
      open={dialogState.open}
      onClose={close}
      size='small'
      position='top'
    >
      <div style={{ padding: '16px' }}>
        <p>
          Set version <strong>{dialogState.version?.definitionVersionId}</strong> as the active definition
          for <strong>{template?.name}</strong>?
        </p>
        {dialogState.version?.description && (
          <p style={{ color: 'var(--text-color-subtle)', fontSize: 'var(--font-size-sm)' }}>
            {dialogState.version.description}
          </p>
        )}
        <SydModalActions>
          {error ? <div className='__error'>{error}</div> : null}
          <SydButton variant='ghost' onClick={close} disabled={processing}>Cancel</SydButton>
          <SydButton variant='primary' onClick={handleSetActive} processing={processing}>Set Active</SydButton>
        </SydModalActions>
      </div>
    </SydModal>
  )
})

SetActiveVersionDialog.propTypes = {
  template: PropTypes.object,
  onComplete: PropTypes.func.isRequired
}

export default SetActiveVersionDialog
